export default {
  api_url: 'http://tgtmon.mooo.com/imms_back',
  ws_address: {
    host: 'tgtmon.mooo.com',
    path: '/imms_ws/socketio',
  },
};
